import { UsersClient } from '@src/manageUsers/services/UsersClient';
import { useMutation } from '@tanstack/react-query';

export const useUserCreation = ({ onSuccess }: { onSuccess: () => void }) => {
  const { mutate, isPending } = useMutation({
    mutationFn: (data: { name: string; email: string; extension?: string }) =>
      UsersClient.create(data),
    onSuccess,
  });

  return {
    createUser: mutate,
    isLoading: isPending,
  };
};
